import { listOf, PermissionScope } from 'mh-client';
import { useParams } from 'react-router';

export const useReauthParamsURL = () => {
    const { setting, action, id } = useParams();
    let url = '';
    let anotherMethodUrl = '';

    if (setting === 'profile') {
        if (action === 'payout-settings') {
            url = '/profile/payout-settings';
            anotherMethodUrl = '/profile/payout-settings';
        }
    } else {
        url =
            setting && action
                ? `/security?${setting}=${action}` +
                  (id ? `&id=${encodeURIComponent(id)}` : '')
                : '/';
        anotherMethodUrl =
            setting && action
                ? `/${setting}/${action}` +
                  (id ? `&id=${encodeURIComponent(id)}` : '')
                : '';
    }

    const isReauth = url.includes('security') || url.includes('profile');

    const scopes = isReauth
        ? listOf([PermissionScope.basic, PermissionScope.security])
        : listOf([PermissionScope.basic]);

    return { url, anotherMethodUrl, isReauth, scopes };
};
